module.exports = __webpack_public_path__ + "static/media/Calibri Regular.5d7c31b2.ttf";